import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";

import { IncidenciaIA } from "../../shared/model/iso42001/incidencia-ia.model";
import { ConfigTableroIso, GestionIncidenciasIsoBase } from "../../shared/incidencias-iso/gestion-incidencias-iso-base";
import { etiquetaOpcion, mensajeErrorHttpIso } from "../../shared/incidencias-iso/incidencias-iso.comun";
import { crearColumnasTablero } from "../../shared/incidencias-iso/tablero-incidencias-base";
import { AsignarResponsableIAComponent } from "../asignar-responsable-ia/asignar-responsable-ia.component";
import {
  TIPO_EVENTO_OPTIONS,
  GRAVEDAD_OPTIONS,
  INCIDENCIA_IA_COLUMNS,
  IncidenciaIAColumn,
  PRIORIDAD_OPTIONS,
} from "../incidencias-ia.constants";
import { DetalleIncidenciaIAComponent } from "../detalle-incidencia-ia/detalle-incidencia-ia.component";
import { IncidenciaIAFormComponent } from "../incidencia-ia-form/incidencia-ia-form.component";
import { IncidenciasIAService } from "../incidencias-ia.service";

@Component({
  selector: "app-gestion-incidencias-ia",
  standalone: true,
  templateUrl: "./gestion-incidencias-ia.component.html",
  styleUrls: ["./gestion-incidencias-ia.component.css"],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTooltipModule,
  ],
})
export class GestionIncidenciasIAComponent extends GestionIncidenciasIsoBase<IncidenciaIAColumn, IncidenciaIA> {
  readonly tipoEventoOptions = TIPO_EVENTO_OPTIONS;
  readonly gravedadOptions = GRAVEDAD_OPTIONS;
  readonly prioridadOptions = PRIORIDAD_OPTIONS;
  readonly columns = crearColumnasTablero<IncidenciaIAColumn, IncidenciaIA>(INCIDENCIA_IA_COLUMNS);

  protected readonly incidenciasService = inject(IncidenciasIAService);
  protected readonly config: ConfigTableroIso = {
    ruta: "/INCIDENCIAS/INC_IA",
    prefijoDialogo: "incidencia-ia",
    errorConsulta: "No fue posible cargar las incidencias IA.",
    componenteDetalle: DetalleIncidenciaIAComponent,
    componenteAsignacion: AsignarResponsableIAComponent,
  };

  abrirAlta(): void {
    const ref = this.dialog.open(IncidenciaIAFormComponent, this.dialogoModulo({ mode: "alta" }));
    ref.afterClosed().subscribe(() => this.refrescarTodas());
  }

  labelTipoEvento(value?: string): string {
    return etiquetaOpcion(value, this.tipoEventoOptions);
  }

  protected abrirFormularioDesdeDetalle(action: "edicion" | "seguimiento", incidencia: IncidenciaIA): void {
    if (!incidencia?.idIncidenciaIa) {
      return;
    }
    const ref = this.dialog.open(
      IncidenciaIAFormComponent,
      this.dialogoModulo({
        mode: action,
        idIncidenciaIa: incidencia.idIncidenciaIa,
        incidencia,
      }),
    );
    ref.afterClosed().subscribe(() => this.refrescarTodas());
  }

  protected override mensajeErrorConsulta(e: any): string {
    return mensajeErrorHttpIso(e, this.config.errorConsulta, {
      servicioNoEncontrado:
        "El backend no encontró el servicio de incidencias IA. Revisa que CosRest esté compilado y reiniciado con el controller actualizado.",
      respuestaNoJson: "El backend respondió una página en lugar de JSON. La ruta de incidencias IA no está llegando al controller.",
    });
  }
}
